/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Upload_New_VersionInputs */

const cs_documents_upload_new_version = /** @type {(inputs: Documents_Upload_New_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrát novou verzi`)
};

const en_documents_upload_new_version = /** @type {(inputs: Documents_Upload_New_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload new version`)
};

/**
* | output |
* | --- |
* | "Upload new version" |
*
* @param {Documents_Upload_New_VersionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_upload_new_version = /** @type {((inputs?: Documents_Upload_New_VersionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Upload_New_VersionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_upload_new_version(inputs)
	return cs_documents_upload_new_version(inputs)
});